export const GLOBAL_HEADER_TEXT = {
  home: 'D3 대시보드 처음으로',
  nav: '주 메뉴',
  searchPlaceholder: '검색어/회사명',
  search: '검색',
  notification: '알림',
  portfolioEvaluation: '포트폴리오 평가',
  file: '파일관리',
  portfolioReport: '추가데이터 관리',
  member: '멤버관리',
  settings: '설정',
  /** 태블릿(`xl` 미만) 햄버거 버튼 · 메뉴 이름 */
  tabletMenu: '메뉴',
} as const;
